import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import { usePathname, useSearchParams } from 'next/navigation';
import React, { useEffect } from 'react';

import { useAuth } from '../providers';
import { TrackExperimentViewed } from '../utils/analytics';
import getAnonymousIdentifier from '../utils/anonymousIdentifier';

const growthbook = new GrowthBook({
  apiHost: process.env.NEXT_PUBLIC_GROWTHBOOK_API_HOST,
  clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: true,
  subscribeToChanges: true,
  trackingCallback(experiment, result) {
    TrackExperimentViewed({
      experimentId: experiment.key,
      variationId: result.variationId,
      growthbookId: result.hashValue || undefined,
    });
  },
});

export const AAGrowthbookProvider: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const { user } = useAuth();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const anonIdentifier = getAnonymousIdentifier();

  const userId = user?.id;

  useEffect(() => {
    // Load features from the GrowthBook API
    growthbook.init({ streaming: true }).catch((error) => {
      console.error('Error initializing GrowthBook', error);
    });
  }, []);

  useEffect(() => {
    growthbook.updateAttributes({
      url: window.location.href,
    });
  }, [pathname, searchParams]);

  useEffect(() => {
    const identifier = userId ?? anonIdentifier;

    growthbook.updateAttributes({
      id: identifier,
    });
  }, [userId, anonIdentifier]);

  return (
    <GrowthBookProvider growthbook={growthbook}>{children}</GrowthBookProvider>
  );
};
